import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import TwoFactorCodeInput from './TwoFactorCodeInput';
export default class TwoFactorChangeDeviceModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    // Statuses: 'verifyCurrentDevice', 'loadingQR', 'displayQR', 'displayBackupCodes', 'final'
    _defineProperty(this, "status", 'verifyCurrentDevice');
    _defineProperty(this, "qrCodeUrl", null);
    _defineProperty(this, "backupCodes", []);
    _defineProperty(this, "currentToken", void 0);
    _defineProperty(this, "newToken", void 0);
    _defineProperty(this, "code", null);
    _defineProperty(this, "activeTab", 'qrcode');
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    this.currentToken = Stream('');
    this.newToken = Stream('');
  }
  className() {
    return 'TwoFactorChangeDeviceModal Modal--small';
  }
  title() {
    return app.translator.trans('ianm-twofactor.forum.security.change_device_heading');
  }
  onupdate() {
    if (this.status === 'verifyCurrentDevice') {
      const tokenInput = document.querySelector('.TwoFactorChangeDeviceModal [name=currentToken]');
      if (tokenInput && document.activeElement !== tokenInput) {
        tokenInput.focus();
      }
    } else if (this.status === 'displayQR') {
      const tokenInput = document.querySelector('.TwoFactorChangeDeviceModal [name=newToken]');
      if (tokenInput && document.activeElement !== tokenInput) {
        tokenInput.focus();
      }
    }
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.status === 'verifyCurrentDevice' && this.renderVerifyCurrentDevice(), this.status === 'loadingQR' && this.renderLoadingQR(), this.status === 'displayQR' && this.renderDisplayQR(), this.status === 'displayBackupCodes' && this.renderBackupCodes(), this.status === 'final' && this.renderFinal());
  }
  renderVerifyCurrentDevice() {
    return m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.verify_current_device_message')), m(Form, null, m("form", {
      onsubmit: this.onVerifyCurrentDeviceSubmit.bind(this)
    }, m("div", {
      className: "Form-group"
    }, m(TwoFactorCodeInput, {
      placeholder: app.translator.trans('ianm-twofactor.forum.security.enter_current_token'),
      initial: this.currentToken(),
      onComplete: code => {
        this.currentToken(code);
        this.verifyCurrentDevice();
      }
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading
    }, app.translator.trans('ianm-twofactor.forum.security.verify_button'))))));
  }
  renderLoadingQR() {
    return m("div", {
      className: "loading"
    }, m(LoadingIndicator, null), m("p", null, app.translator.trans('ianm-twofactor.forum.security.loading_qr')));
  }
  renderDisplayQR() {
    return m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.scan_new_device_qr')), m("div", {
      className: "tabs"
    }, m(Button, {
      className: "TwoFactorModal-tab ".concat(this.activeTab === 'qrcode' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'qrcode';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.qr_tab')), m(Button, {
      className: "TwoFactorModal-tab ".concat(this.activeTab === 'manual' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'manual';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.manual_tab'))), this.activeTab === 'qrcode' && m("div", {
      className: "qrSection"
    }, m("img", {
      className: "qrImage",
      src: this.qrCodeUrl,
      alt: app.translator.trans('ianm-twofactor.forum.security.qr_code_alt')
    })), this.activeTab === 'manual' && m("div", {
      className: "manualEntrySection"
    }, m("code", {
      className: "manualEntryCode"
    }, this.code), m("p", {
      className: "helpText"
    }, app.translator.trans('ianm-twofactor.forum.security.manual_entry_instruction'))), m("p", null, app.translator.trans('ianm-twofactor.forum.security.verify_new_device_message')), m(Form, null, m("form", {
      onsubmit: this.onVerifyNewDeviceSubmit.bind(this)
    }, m("div", {
      className: "Form-group"
    }, m(TwoFactorCodeInput, {
      placeholder: app.translator.trans('ianm-twofactor.forum.security.enter_new_token'),
      initial: this.newToken(),
      onComplete: code => {
        this.newToken(code);
        this.verifyNewDevice();
      }
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading
    }, app.translator.trans('ianm-twofactor.forum.security.verify_button'))))));
  }
  renderBackupCodes() {
    return m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.new_backup_codes')), m("ul", null, this.backupCodes.map(code => m("li", null, m("code", null, code)))), m("p", null, app.translator.trans('ianm-twofactor.forum.security.backup_codes_instruction')), m(Button, {
      className: "Button Button--primary",
      onclick: () => {
        this.status = 'final';
        m.redraw();
      }
    }, app.translator.trans('ianm-twofactor.forum.security.saved_backup_codes_button')));
  }
  renderFinal() {
    return m("div", null, m("p", null, app.translator.trans('ianm-twofactor.forum.security.device_changed_confirmation')), m(Button, {
      className: "Button Button--primary",
      onclick: this.finish.bind(this)
    }, app.translator.trans('ianm-twofactor.forum.security.continue_button')));
  }
  onVerifyCurrentDeviceSubmit(e) {
    e.preventDefault();
    this.verifyCurrentDevice();
  }
  verifyCurrentDevice() {
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/users/twofactor/verify-current',
      body: {
        token: this.currentToken()
      }
    }).then(() => {
      this.status = 'loadingQR';
      m.redraw();
      this.loadQrCode();
    }).catch(error => {
      this.loading = false;
      m.redraw();
    });
  }
  loadQrCode() {
    const userId = this.user.id();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/users/".concat(userId, "/twofactor/change-device/qrcode")
    }).then(response => {
      this.qrCodeUrl = response.svg;
      this.code = response.code;
      this.status = 'displayQR';
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  onVerifyNewDeviceSubmit(e) {
    e.preventDefault();
    this.verifyNewDevice();
  }
  verifyNewDevice() {
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/users/twofactor/change-device/verify',
      body: {
        token: this.newToken()
      }
    }).then(response => {
      const _ref = response,
        backupCodes = _ref.backupCodes;
      this.backupCodes = backupCodes;
      this.status = 'displayBackupCodes';
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  finish() {
    var _this$attrs$onDeviceC, _this$attrs;
    (_this$attrs$onDeviceC = (_this$attrs = this.attrs).onDeviceChanged) == null || _this$attrs$onDeviceC.call(_this$attrs);
    this.hide();
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorChangeDeviceModal', TwoFactorChangeDeviceModal);